import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { SupabaseContext } from '../App';

function ParticipateQuiz() {
  const { supabase, session } = useContext(SupabaseContext);
  const [code, setCode] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!code) return alert('Please enter a quiz code.');

    try {
      const { data: quiz, error: quizError } = await supabase
        .from('quizzes')
        .select('id, attempt_limit')
        .eq('code', code.toUpperCase())
        .single();
      if (quizError) throw new Error('Invalid quiz code.');

      if (session) {
        const { data: history, error: historyError } = await supabase
          .from('quiz_history')
          .select('id')
          .eq('quiz_id', quiz.id)
          .eq('user_id', session.user.id);
        if (historyError) throw historyError;

        if (quiz.attempt_limit && history.length > 0) {
          return alert('You have already attempted this quiz, and it allows only one attempt.');
        }
      }

      navigate(`/quiz/${code.toUpperCase()}`);
    } catch (error) {
      alert('Error: ' + error.message);
    }
  };

  return (
    <div className="page-container">
      <div className="auth-card">
        <h2>Join a Quiz</h2>
        <div className="form-group">
          <label>Quiz Code</label>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Enter quiz code"
          />
        </div>
        <div className="button-group">
          <button onClick={handleSubmit}>Join Quiz</button>
          <button className="secondary-btn" onClick={() => navigate('/')}>Back to Home</button>
        </div>
      </div>
    </div>
  );
}

export default ParticipateQuiz;